import React from 'react';

import Product from 'components/Tvendo/Article/DataMaster/Product/List.js';

export default function () {
  return <Product />;
}
